import trim from 'lodash/trim';


export function validatePropKey(value) {
  if (!(/^[a-z0-9_]+$/.test(value))) return "Lowercase alphanumeric characters and underscores only.";
  if (value !== trim(value, "_")) return "Underscores can't be at start and end of key";
  if (value !== value.replace(/_+/g, '_')) return "Must not have consecutive underscores";
  return;
}
